var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleHandleMedicineBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85563 16.3892C4.21676 16.9095 4.81869 17.25 5.5 17.25C6.60457 17.25 7.5 16.3546 7.5 15.25V8.75C7.5 7.64543 6.60457 6.75 5.5 6.75C4.81793 6.75 4.21561 7.09143 3.85462 7.6127M3.85563 16.3892C5.41875 19.2835 8.47973 21.25 12 21.25C15.5203 21.25 18.5812 19.2835 20.1444 16.3892M3.85563 16.3892C3.15035 15.0832 2.75 13.5884 2.75 12C2.75 10.4124 3.14996 8.91821 3.85462 7.6127M3.85462 7.6127C5.41743 4.71731 8.47897 2.75 12 2.75C15.521 2.75 18.5826 4.71731 20.1454 7.6127M20.1444 16.3892C19.7832 16.9095 19.1813 17.25 18.5 17.25C17.3954 17.25 16.5 16.3546 16.5 15.25V8.75C16.5 7.64543 17.3954 6.75 18.5 6.75C19.1821 6.75 19.7844 7.09143 20.1454 7.6127M20.1444 16.3892C20.8497 15.0832 21.25 13.5884 21.25 12C21.25 10.4124 20.85 8.91821 20.1454 7.6127",
    stroke: "#191C1E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleHandleMedicineBall);
export default __webpack_public_path__ + "static/media/doubleHandleMedicineBall.350d25414d20180c4eb18caff9417258.svg";
export { ForwardRef as ReactComponent };